export default __webpack_public_path__ + "static/media/Gallery_3.d036b285.jpg";